import { create } from 'zustand';

const initialPayment = {
  method: 'cash',
  cashboxId: null,
  paidAmount: 0,
  // مصير الفرق عند تحصيل مبلغ أقل من المستحق: null | 'waive' | 'debt'
  shortfall: null
};

const initialOverride = {
  active: false,
  amount: 0,
  reason: '',
  // معرّف الخصم الجاهز المختار من الإعدادات (إن وُجد). null = خصم يدوي.
  presetId: null
};

export const useCheckout = create((set, get) => ({
  sessionId: null,
  // الأطفال المختارون للمحاسبة من مجموعة الكارت المشترك
  selectedIds: [],
  scanUid: '',
  searchQ: '',
  payment: { ...initialPayment },
  override: { ...initialOverride },
  // إلغاء خصم الأشقاء التلقائي لهذه الجلسة (الكاشير يقدر يطفّيه لطفل معيّن).
  skipSibling: false,
  receiptOpen: false,
  receiptData: null,

  setSessionId: (id) => set({ sessionId: id || null, selectedIds: id ? [id] : [] }),
  clearSession: () =>
    set({
      sessionId: null,
      selectedIds: [],
      scanUid: '',
      searchQ: '',
      payment: { ...initialPayment },
      override: { ...initialOverride },
      skipSibling: false,
      receiptOpen: false,
      receiptData: null
    }),

  setSelectedIds: (ids) => set({ selectedIds: Array.isArray(ids) ? ids : [] }),
  toggleSelected: (id) =>
    set((s) => ({
      selectedIds: s.selectedIds.includes(id)
        ? s.selectedIds.filter((x) => x !== id)
        : [...s.selectedIds, id]
    })),

  setScanUid: (uid) => set({ scanUid: uid || '' }),
  setSearchQ: (q) => set({ searchQ: q || '' }),

  setPayment: (patch) => set((s) => ({ payment: { ...s.payment, ...patch } })),
  resetPayment: () => set({ payment: { ...initialPayment } }),

  setOverride: (patch) => set((s) => ({ override: { ...s.override, ...patch } })),
  toggleOverride: (active) =>
    set((s) => ({ override: { ...s.override, active: active ?? !s.override.active } })),
  resetOverride: () => set({ override: { ...initialOverride } }),

  setSkipSibling: (v) => set({ skipSibling: !!v }),

  openReceipt: (data) => set({ receiptOpen: true, receiptData: data }),
  closeReceipt: () => set({ receiptOpen: false }),

  // selectors
  isReady: () => !!get().sessionId
}));
